import { useBreakpointValue } from '@chakra-ui/react';
import React, { createContext, PropsWithChildren, useContext } from 'react';

type SizeContext = {
  fontSize: {
    rawMessage?: string | number;
    rawHeader?: string | number;
    listMessage?: string | number;
    listMessageEmphasis?: string | number;
    listHeader?: string | number;
    accordionHeader?: string | number;
    accordionBody?: string | number;
    confirmMessage?: string | number;
    modalHeader?: string | number;
    modalBody?: string | number;
    modalBodyTitle?: string | number;
    modalButton?: string | number;
    iconSize?: string | number;
  };
  width: {
    styledMessageList?: string | number;
  };
};

const contextValue: SizeContext = { fontSize: {}, width: {} };
const sizeContext = createContext<SizeContext>(contextValue);

export const useSizeContext = () => useContext(sizeContext);

/**
 * ブレイクポイント依存のサイズ値のプロバイダ
 * @param props -
 * @returns
 */
export const SizeProvider: React.FunctionComponent<PropsWithChildren> = (
  props
) => {
  const rawMessage = useBreakpointValue({ base: 'md' }); // { base: 'mobile.md', md: 'xl' }
  const rawHeader = useBreakpointValue({ base: 'xl' });
  const listMessage = useBreakpointValue({ base: 'sm', md: 'lg' });
  const listMessageEmphasis = useBreakpointValue({
    base: 'sm',
    md: 'lg',
  });
  const listHeader = useBreakpointValue({ base: 'md', md: 'xl' });
  const accordionHeader = useBreakpointValue({ base: 'md', md: 'lg' });
  const accordionBody = useBreakpointValue({ base: 'xs', md: 'md' });
  const confirmMessage = useBreakpointValue({ base: 'md' });
  const modalHeader = useBreakpointValue({ base: 'xl' });
  const modalBody = useBreakpointValue({ base: 'lg', md: 'md' });
  const modalBodyTitle = useBreakpointValue({ base: 'lg' });
  const modalButton = useBreakpointValue({ base: 'lg' });
  const iconSize = useBreakpointValue({ base: 'lg' });

  // const rawMessage = useBreakpointValue({ base: 'mobile.2xl', md: 'md' }); // { base: 'mobile.md', md: 'xl' }
  // const rawHeader = useBreakpointValue({ base: 'mobile.4xl', md: 'xl' });
  // const listMessage = useBreakpointValue({ base: 'mobile.xs', md: 'lg' });
  // const listMessageEmphasis = useBreakpointValue({
  //   base: 'mobile.sm',
  //   md: 'lg',
  // });
  // const listHeader = useBreakpointValue({ base: 'mobile.md', md: 'xl' });
  // const accordionHeader = useBreakpointValue({ base: 'mobile.md', md: 'lg' });
  // const accordionBody = useBreakpointValue({ base: 'mobile.xs', md: 'md' });
  // const confirmMessage = useBreakpointValue({ base: 'mobile.lg', md: 'md' });
  // const modalHeader = useBreakpointValue({ base: 'mobile.4xl', md: 'xl' });
  // const modalBody = useBreakpointValue({ base: 'mobile.lg', md: 'md' });
  // const modalBodyTitle = useBreakpointValue({ base: 'mobile.3xl', md: 'lg' });
  // const modalButton = useBreakpointValue({ base: 'mobile.2xl', md: 'lg' });
  // const iconSize = useBreakpointValue({ base: 'mobile.3xl', md: 'lg' });

  const styledMessageList = useBreakpointValue({ base: 'full', lg: '70%' });

  const values: SizeContext = {
    fontSize: {
      rawMessage,
      rawHeader,
      listMessage,
      listHeader,
      listMessageEmphasis,
      accordionHeader,
      accordionBody,
      confirmMessage,
      modalHeader,
      modalBody,
      modalBodyTitle,
      modalButton,
      iconSize,
    },
    width: { styledMessageList },
  };

  return (
    <sizeContext.Provider value={values}>{props.children}</sizeContext.Provider>
  );
};
